module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel slider-navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "containerItem2"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('a', {
      staticClass: "img",
      style: (("background-image: url(" + (item.img) + ")")),
      attrs: {
        "href": item.href
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('a', {
      attrs: {
        "href": item.href
      }
    }, [_c('b', [_vm._v(_vm._s(item.text))])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('div', {
      staticClass: "time"
    }, [_c('span', [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "width": "16",
        "height": "17",
        "viewBox": "0 0 16 17"
      }
    }, [_c('metadata', [_vm._v("<?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?> "), _c('x:xmpmeta', {
      attrs: {
        "xmlns:x": "adobe:ns:meta/",
        "x:xmptk": "Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39 "
      }
    }, [_c('rdf:RDF', {
      attrs: {
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      }
    }, [_c('rdf:Description', {
      attrs: {
        "rdf:about": ""
      }
    })], 1)], 1), _vm._v(" <?xpacket end=\"w\"?>")], 1), _vm._v(" "), _c('image', {
      attrs: {
        "id": "icons8-time",
        "width": "16",
        "height": "17",
        "xlink:href": "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA/FBMVEVESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk4AAAAEhMBKAAAAUnRSTlMAIfb7/PdqiodoExV9sdDLrHgRueVmnp/RZcbMeqcg+GdXTIWII9Pd2O9EP1nNCT6UATzZe46vb1qjGeLkKh0MHw8Okzg6kc5Nw2QzxMUIYuZheZRjHgAAAAFiS0dEU3pnHQYAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhCxsRGh0vy9xNAAAAwklEQVQY002P11ICURBEG1gEhSXnIFFAJIjkoCRJuwTp//8YdxYo6IfpPj1Tt+oCIovVptgteNCTw/ksi5cLutyqx+vzBxAMuYTDpCcSjZHxBJMGp5g2L19VZrI5IM/C7aUi34xpLUEtX5vKO1DlB2qsN8yiyiY+2QK+2O5I1WIXPbus+uRAPOPDUJEwGk++xZUhsvyRNJ3KnDGOOSP3H0S5AJb8vfGKa7EN8xfesm56I8Gdpuvanofj9fT0R0Ohs+R/wXcaDJiUt84AAAAASUVORK5CYII="
      }
    })], 1)]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.time) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('a', {
      staticClass: "button",
      attrs: {
        "href": item.href
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.button) + "\n\t\t\t\t")])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ca4f032"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/otherStock.vue
// module id = 256
// module chunks = 38